module.exports = __webpack_public_path__ + "assets/be9ae8a9e24d04138a643761d8b99047.icon_card.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_card.svg
 ** module id = 833
 ** module chunks = 1
 **/